export function formatearNumero(numero) {
  const formatter = new Intl.NumberFormat("es-DO");
  return formatter.format(numero);
}

export function separarPorMayuscula(str) {
  // prettier-ignore
  const excepciones = ["CxC","CxP","EULA","PDPS","MPR","ISR","ITBIS","DGII","NCF","XML","NcF","IF",
  "IR3","606","607","608","609","IR17","IT1","RRHH","POS","ARS", "IR9", "TSS", "VSN", "72", "24", "2000"];
  let result = "";
  for (let i = 0; i < str?.length; i++) {
    const char = str[i];
    if ((char === char.toUpperCase() && char !== char.toLowerCase()) || !isNaN(char)) {
      const exception = excepciones.find((e) => str.substr(i, e?.length) === e);
      if (exception) {
        if (result) result += " ";
        result += exception;
        i += exception?.length - 1;
      } else {
        result += " " + char;
      }
    } else {
      result += char;
    }
  }
  return result;
}

export function formatear2Decimales(numero) {
  if (typeof numero !== "number") {
    return null;
  }

  const formatter = new Intl.NumberFormat("es-Do", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(numero);
}

export const REPORTE_EXPRESAR = {
  EN_MILES: "K",
  EN_CIENTOS_MILES: "CK",
  EN_MILLONES: "M",
  EN_UNIDADES: "U",
};
export function formatearNumeroPorTipoExpresion(monto, expresado) {
  let formateado = monto;
  switch (expresado) {
    case REPORTE_EXPRESAR.EN_MILES:
      formateado /= 1000;
      break;
    case REPORTE_EXPRESAR.EN_CIENTOS_MILES:
      formateado /= 100000;
      break;
    case REPORTE_EXPRESAR.EN_MILLONES:
      formateado /= 1000000;
      break;
    case REPORTE_EXPRESAR.EN_UNIDADES:
      formateado = Math.round(formateado);
      break;
    default:
      break;
  }
  return formateado;
}
